import { useState, useCallback } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function calculateCenterPoint(targetWidth, targetHeight) {
  var screenX = window.screenX || window.screenLeft;
  var screenY = window.screenY || window.screenTop;
  var outerWidth = window.outerWidth || document.documentElement.clientWidth;
  var outerHeight = window.outerHeight || document.documentElement.clientHeight;
  var left = screenX + (outerWidth - targetWidth) / 2;
  var top = screenY + (outerHeight - targetHeight) / 2;
  return {
    left: left,
    top: top
  };
}

function windowOptionsMapper(object) {
  var options = Object.entries(object).map(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return key + "=" + value;
  });
  return options.join(',');
}

var defaultOptions = {
  name: "_blank",
  centered: true,
  focus: true,
  specs: {
    height: 300,
    width: 600,
    scrollbars: "yes"
  }
};

var getUrlAndOptions = function getUrlAndOptions(urlOrOptions, optionsArg) {
  var url = "";
  var options = {};

  if (typeof urlOrOptions === "object") {
    url = urlOrOptions.url;
    options = urlOrOptions;
  } else {
    url = urlOrOptions;
    options = optionsArg || {};
  }

  return [url, options];
};

function useOpenInWindow(urlOrOptions, optionsArg) {
  var _useState = useState(),
      newWindowHandler = _useState[0],
      setNewWindowHandler = _useState[1];

  var _getUrlAndOptions = getUrlAndOptions(urlOrOptions, optionsArg),
      url = _getUrlAndOptions[0],
      options = _getUrlAndOptions[1];

  var openInWindow = useCallback(function (event, callbackOptions) {
    event == null ? void 0 : event.preventDefault == null ? void 0 : event.preventDefault();
    var specs = options.specs;
    var defaultSpecs = defaultOptions.specs;

    var mixedOptions = _extends({}, defaultOptions, options);

    var mixedSpecs = _extends({}, defaultSpecs, specs);

    var urlToOpen = (callbackOptions == null ? void 0 : callbackOptions.url) || url; // If options passed as first argument then serve different callback

    if (typeof callbackOptions === "object") {
      var callbackSpecs = callbackOptions.specs;
      mixedOptions = _extends({}, mixedOptions, callbackOptions);
      mixedSpecs = _extends({}, mixedSpecs, callbackSpecs);
    }

    var _mixedOptions = mixedOptions,
        focus = _mixedOptions.focus,
        name = _mixedOptions.name,
        centered = _mixedOptions.centered;
    var windowOptions = "";

    if (centered) {
      var _mixedSpecs = mixedSpecs,
          width = _mixedSpecs.width,
          height = _mixedSpecs.height,
          restSpecs = _objectWithoutPropertiesLoose(_mixedSpecs, ["width", "height"]);

      var centerPoint = calculateCenterPoint(width, height);
      windowOptions = windowOptionsMapper(_extends({
        width: width,
        height: height
      }, centerPoint, restSpecs));
    } else {
      windowOptions = windowOptionsMapper(mixedSpecs);
    }

    var newWindow = window.open(urlToOpen, name, windowOptions); // Puts focus on the newWindow

    if (focus && newWindow) newWindow.focus();
    setNewWindowHandler(newWindow);
  }, [url, options, setNewWindowHandler]);
  return [openInWindow, newWindowHandler];
}

export { calculateCenterPoint, defaultOptions, useOpenInWindow, windowOptionsMapper };
//# sourceMappingURL=use-open-window.esm.js.map
